import { styled } from "@mui/material/styles";
import { EmtTypography } from "./EmtTypography";
import Box from "@mui/material/Box";
import { EmtTheme } from "../types";

export type EmtFormLabelCaptionProps = {
  label: string;
  caption?: string | React.ReactNode | React.ReactNode[];
  nonce?: string;
};

const StyledCaptionTypography = styled(EmtTypography)(
  ({ theme }: { theme?: EmtTheme }) => ({
    color: theme?.palette.greyGradient
      ? theme?.palette.greyGradient[250]
      : theme?.palette.greyGradient[200],
  })
);

export function EmtFormLabelCaption({
  label,
  caption,
}: EmtFormLabelCaptionProps) {
  return (
    <Box
      sx={{ marginLeft: "10px", ...(caption ? { paddingTop: "11px" } : {}) }}
    >
      <EmtTypography
        variant="body2"
        sx={{ fontWeight: "bold", lineHeight: caption ? 0 : 1 }}
      >
        {label}
      </EmtTypography>
      {caption && (
        <StyledCaptionTypography variant="caption">
          {caption}
        </StyledCaptionTypography>
      )}
    </Box>
  );
}
